"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//: начало - добавление светильников на сайт
const panels_1 = require("../../../ajax/panels");
const lustre_light_1 = require("../../../ajax/lustre-light");
const lustre_spot_1 = require("../../../ajax/lustre-spot");
const lustre_dot_1 = require("../../../ajax/lustre-dot");
const addFilterLamps_1 = __importDefault(require("./addFilterLamps"));
const filterLamps_1 = __importDefault(require("./filterLamps"));
const create_1 = __importDefault(require("./create"));
const toggleActivityFitter_1 = __importDefault(require("./toggleActivityFitter"));
const lampsStringArray = ['panels', 'trek', 'lustre', 'dot', 'light', 'spot'];
const isTypeLamps = (str) => {
    return lampsStringArray.includes(str);
};
//= lamps 
const lamps = () => {
    try {
        const lampsBlock = document.querySelector('#box-for-lamp');
        if (lampsBlock) {
            const typeLamps = lampsBlock.dataset.lamp;
            // значение приходящее из [ data-lamp=" тут получаемое значение " ]
            const allLamps = {
                panels: panels_1.panels,
                trek: panels_1.trek,
                lustre: panels_1.lustre,
                dot: lustre_dot_1.lustreDot,
                light: lustre_light_1.light,
                spot: lustre_spot_1.spot
            };
            let currentArrLamps = [];
            // установка текушего массива для страницы
            //* проверка ключа на соответствие type TypeLamps
            if (typeLamps && isTypeLamps(typeLamps)) {
                currentArrLamps = allLamps[typeLamps];
                (0, addFilterLamps_1.default)(currentArrLamps, typeLamps);
                // добавляем элементы фильтрации
            }
            (0, create_1.default)(currentArrLamps);
            //* обработчик кнопкок активности фильтра
            (0, toggleActivityFitter_1.default)();
            //* метод фильтрации
            (0, filterLamps_1.default)(currentArrLamps);
        }
    }
    catch (error) {
        console.log('Error in function lamps >>> ', error);
    }
};
exports.default = lamps;
